<template>
    <div class="modal fade show d-block" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">{{ $t('deleteBatch') }}</h5>
                    <button type="button" class="btn-close" @click="$emit('close')" :disabled="deleting"></button>
                </div>
                <div class="modal-body">
                    <div v-if="!deleting && !result">
                        <p>{{ $t('confirmDeleteBatch') }}</p>
                        <p class="fw-bold">{{ batch.name }}</p>
                    </div>
                    <div v-if="deleting" class="text-center py-3">
                        <div class="spinner-border text-primary mb-2" role="status"></div>
                        <div class="text-muted">{{ $t('deleting') }}...</div>
                    </div>
                    <div v-if="result" class="text-center py-3">
                        <i :class="result === 'success' ? 'fas fa-check-circle text-success' : 'fas fa-times-circle text-danger'" style="font-size: 32px"></i>
                        <div class="mt-2">{{ resultMessage }}</div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button v-if="result" type="button" class="btn btn-secondary" @click="$emit('close')">
                        {{ $t('close') }}
                    </button>
                    <template v-if="!deleting && !result">
                        <button type="button" class="btn btn-secondary" @click="$emit('close')">
                            {{ $t('cancel') }}
                        </button>
                        <button type="button" class="btn btn-danger" @click="deleteBatch">
                            <i class="fas fa-trash-alt"></i> {{ $t('delete') }}
                        </button>
                    </template>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-backdrop fade show"></div>
</template>

<script>
import DataBatchApi from '../../api/server/databatch';

export default {
    name: 'DataBatchDeleteModal',
    props: {
        batch: { type: Object, required: true }
    },
    data() {
        return {
            deleting: false,
            result: null,
            resultMessage: ''
        };
    },
    computed: {
        dataSpaceId() {
            return this.$route.params.id;
        }
    },
    methods: {
        async deleteBatch() {
            this.deleting = true;
            this.result = null;
            try {
                await DataBatchApi.dataBatchDelete(this.dataSpaceId, this.batch.id);
                this.result = 'success';
                this.resultMessage = this.$t('batchDeleteSuccessful');
            } catch (error) {
                this.result = 'error';
                var key = error?.response?.body?.message || 'unknownError';
                this.resultMessage = this.$t(key);
            } finally {
                this.deleting = false;
                this.$emit('reload');
            }
        }
    }
};
</script>